import { GetMainSectionFn, TopicSectionBuilder } from '../custom-topic-routes'
import { billboardLeaderboardMrec } from 'thewest/routes/ad-units'
import { subscriberExclusive } from 'thewest/routes/home/subscriber-exclusive'
import { layout } from 'thewest/App.routing'

const heroSegment = layout.component({
    type: 'sierra',
    props: {
        verticalSpacing: 'gridGap',
        fixedRatios: ['16:9'],
        heroImageLayout: 'fill-container-horizontally',
        cardOrientation: {
            type: 'Landscape-Portrait',
            maxBreakpoint: 'md',
        },
        cardLayout: ['hero', 'commonWithBackground'],
        dataDefinitionArgs: {
            type: 'curation',
            name: 'countryman',
            offset: 0,
            pageSize: 2,
        },
    },
})

const subheroSegment = layout.component({
    type: 'uniform',
    props: {
        section: 'default',
        verticalSpacing: 'lg',
        cardOrientation: { type: 'Landscape-Portrait' },
        cardLayout: [
            { type: 'november', listLength: 5 },
            ['teaserWithBackground'],
            ['noImageWithBackground', 'noImageWithBackground'],
            ['noImageWithBackground', 'noImageWithBackground'],
        ],
        dataDefinitionArgs: {
            type: 'curation',
            name: 'countryman',
            offset: 2,
            pageSize: 10,
        },
    },
})

const revChronSegment = layout.component({
    type: 'lima',
    props: {
        verticalSpacing: 'lg',
        fontScale: 1.2,
        fixedRatios: ['16:9'],
        hasBackground: true,
        hideTeaser: true,
        initialColumns: 1,
        intermediateColumns: 2,
        finalColumns: 4,
        cardOrientation: { type: 'Landscape-Portrait' },
        cardLayout: [
            ['teaserWithBackground'],
            [
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
            ],
            ['teaserWithBackground'],
            ['teaserWithBackground'],
        ],
        dataDefinitionArgs: {
            type: 'listing',
            topics: ['countryman'],
            includeSubTopics: false,
            paging: {
                page: 1,
                pageSize: 6,
            },
        },
    },
})

export const getCountrymanCuratedSection: TopicSectionBuilder['getCuratedSection'] = () => {
    return [heroSegment, subheroSegment, ...billboardLeaderboardMrec('one'), revChronSegment]
}

export const getCountrymanRouteInfo: GetMainSectionFn = sectionBuilder => {
    return [
        ...sectionBuilder.getCuratedSection(),
        subscriberExclusive(true),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'News',
                    headingUrl: '/countryman/news',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/news'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('two'),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Livestock',
                    headingUrl: '/countryman/livestock',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/livestock'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Grain',
                    headingUrl: '/countryman/grain',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/grain'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('three'),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Opinion',
                    headingUrl: '/countryman/opinion',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/opinion'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Horticulture',
                    headingUrl: '/countryman/horticulture',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/horticulture'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Finance & Markets',
                    headingUrl: '/countryman/finance-markets',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/finance-markets'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('four'),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Machinery',
                    headingUrl: '/countryman/machinery',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/machinery'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Wool',
                    headingUrl: '/countryman/wool',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/wool'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Homestead',
                    headingUrl: '/countryman/homestead',
                    section: 'generic',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['countryman/homestead'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
    ]
}
